<template>
  <div>
    <transition name="fade" appear>
      <div class="hero columns has-background-success is-fullheight is-mobile is-centered is-vcentered" v-show="display === `landingpage`">
        <div class="column is-four-fifths-mobile is-half-tablet is-two-third-desktop is-one-third-widescreen is-one-third-fullhd">
          <feedback-welcome-page :campaignData="feedbackCampaign" v-on:displayfeedback="display = `feedbackform`"></feedback-welcome-page>
        </div>
      </div>
    </transition>
    <transition name="fade">
      <div class="columns is-centered is-vcentered is-full-mobile" v-show='display === `feedbackform`'>
        <div class="column is-two-thirds-tablet is-two-thirds-desktop is-two-thirds-widescreen is-two-thirds-fullhd">
          <feedback-stepper :campaignData="feedbackCampaign" v-on:submit="feedbackSubmit" v-on:customerinfo="displayCustomerForm"></feedback-stepper>
        </div>
      </div>
    </transition>
    <transition name="fade">
      <div class="hero is-fullheight is-full-mobile columns is-centered is-vcentered" v-show='display === `customerform`'>
        <div class="column is-two-thirds-tablet is-two-thirds-desktop is-two-thirds-widescreen is-two-thirds-fullhd">
          <customer-info-form v-on:submit="summarizeFeedback" :campaignData="feedbackCampaign"></customer-info-form>
        </div>
      </div>
    </transition>
    <transition name="fade">
      <div class="hero columns has-background-success is-fullheight is-mobile is-centered is-vcentered" v-show="display === 'thankyoupage'">
        <div class="column is-four-fifths-mobile is-half-tablet is-two-third-desktop is-one-third-widescreen is-one-third-fullhd">
          <div class="card">
              <div class="card-content" >
                 <p class="title has-text-centered" v-if="feedbackCampaign.campaign && feedbackCampaign.campaign.completionMsg">{{feedbackCampaign.campaign.completionMsg}}</p>
                 <p class="title has-text-centered" v-else>Thank you for your feedback. Have a nice day!</p>
              </div>
            </div>
        </div>
      </div>
    </transition>
    <transition name="fade">
      <div class="hero columns has-background-white-bis is-fullheight is-mobile is-centered is-vcentered" v-show="display === 'feedbackError'">
        <div class="column is-four-fifths-mobile is-half-tablet is-two-third-desktop is-one-third-widescreen is-one-third-fullhd">
          <div class="notification is-info is-size-3 has-text-centered">{{feedbackError.message}}</div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import FeedbackWelcomePage from './FeedbackWelcomePage'
import FeedbackStepper from './FeedbackStepper'
import CustomerInfoForm from './CustomerInfoForm'
import { mapState } from 'vuex'

export default {
  title: 'Feedback',
  name: 'FeedbackPage',
  components: {
    FeedbackWelcomePage,
    FeedbackStepper,
    CustomerInfoForm
  },
  data () {
    return {
      display: 'landingpage',
      feedbackResult: {}
    }
  },
  props: ['campaignParams'],
  computed: {
    ...mapState('feedback', ['feedbackCampaign', 'feedbackCompleted', 'feedbackError'])
  },
  created () {
    this.getFeedbackCampaign()
  },
  watch: {
    feedbackCompleted (feedbackCompleted) {
      if (feedbackCompleted) {
        this.display = 'thankyoupage'
      }
    },
    feedbackError (feedbackError) {
      this.display = 'feedbackError'
    }
  },
  methods: {
    getFeedbackCampaign () {
      this.$store.dispatch('feedback/getFeedbackCampaign', this.campaignParams)
    },

    displayCustomerForm (feedbackItems) {
      this.feedbackResult = feedbackItems
      this.display = 'customerform'
    },

    summarizeFeedback (customerInfo) {
      this.feedbackResult = Object.assign({}, this.feedbackResult, customerInfo)
      this.feedbackSubmit(this.feedbackResult)
    },

    feedbackSubmit (feedbackResult) {
      this.$store.dispatch('feedback/submitFeedback', feedbackResult)
    }
  }
}
</script>
